var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 2.75H4.58333C3.57081 2.75 2.75 3.57081 2.75 4.58333C2.75 5.59586 3.57081 6.41667 4.58333 6.41667H16.5C16.5 5.56419 16.5 5.13795 16.4063 4.78824C16.152 3.83925 15.4107 3.09799 14.4618 2.8437C14.1121 2.75 13.6858 2.75 12.8333 2.75Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.25H13.75C16.3427 19.25 17.6391 19.25 18.4445 18.4446C19.25 17.6391 19.25 16.3427 19.25 13.75V11.9167C19.25 9.32401 19.25 8.02762 18.4445 7.22216C17.6391 6.41671 16.3427 6.41671 13.75 6.41671H6.41667M2.75 11V4.58337",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 11H17.4166C16.9903 11 16.7772 11 16.6024 11.0468C16.1278 11.174 15.7572 11.5446 15.6301 12.0192C15.5833 12.194 15.5833 12.4071 15.5833 12.8333C15.5833 13.2596 15.5833 13.4727 15.6301 13.6475C15.7572 14.1221 16.1278 14.4927 16.6024 14.6198C16.7772 14.6667 16.9903 14.6667 17.4166 14.6667H19.2499",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 16.0417H5.95833M5.95833 16.0417H2.75M5.95833 16.0417V12.8334M5.95833 16.0417V19.25",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCollection);
export default __webpack_public_path__ + "static/media/payment-collection.5fb507a89fb6a3782a847fde720b0e4b.svg";
export { ForwardRef as ReactComponent };